import React from "react";

const Java_Else = () => {
  return (
    <div>
      <h1>Java Else</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Else in Java.</p>
    </div>
  );
};

export default Java_Else;
